<template>
    <div class="card mb-3">
        <div class="card-header">
            <i class="fa fa-briefcase"></i> 
            <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{ $t('role.create.title') }}</span>
            <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('role.edit.title') }}</span>
            <span v-if="compMode == CRUDMODE.READ">{{ $t('role.view.title') }}</span>
        </div>
        <div class="card-body">

            <errorMessage v-bind:message="error"></errorMessage>

            <form>

                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="nameInput">{{ $t('role.form.name') }}*</label>
                        <input v-model.trim="role.name" v-validate="'required'" name="name" type="text" class="form-control" 
                           id="nameInput" v-bind:placeholder="$t('role.form.name')" />
                        <span class="text-danger" v-if="errors.has('name')">{{ errors.first('name') }}</span>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="displayNameInput">{{ $t('role.form.displayName') }}*</label>
                        <input v-model.trim="role.displayName" v-validate="'required'" name="displayName" type="text" class="form-control" 
                           id="displayNameInput" v-bind:placeholder="$t('role.form.displayName')" />
                        <span class="text-danger" v-if="errors.has('displayName')">{{ errors.first('displayName') }}</span>
                    </div>
                </div>

                <div class="form-group">
                    <label for="descriptionInput">{{ $t('role.form.description') }}</label>
                    <textarea v-model.trim="role.description" name="comments" type="text" class="form-control" id="descriptionInput" 
                        :placeholder="$t('role.form.description')" ></textarea>
                </div>

               <div class="row" v-if="permissions != null && permissions.length > 0">
                    <div class="form-group col-md-12">
                        <div class="card">
                            <div class="card-header">{{ $t('role.form.permissions') }}</div>
                            <div class="card-body">

                                <div class="row" >
                                    <div class="form-group col-md-3" v-for="permission in permissions">
                                        <label for="permissionInput">{{ permission.displayName }}</label>
                                        <div class="col-9">
                                            <label class="custom-control custom-checkbox">
                                                <input type="checkbox" name="permission" value="1" class="custom-control-input"  
                                                id="permissionInput" :checked="permission.checked" :disabled="compMode == CRUDMODE.READ" v-model="permission.checked" >
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-label">{{$t("yes")}}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

               <a @click="createRole" v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY" id="addButton" class="btn btn-primary">
                    {{ $t('form.create_button') }}
                </a>

                <a @click="editRole" v-if="compMode == CRUDMODE.UPDATE" id="editButton" class="btn btn-primary">
                    {{ $t('form.edit_button') }}
                </a>
                
            </form>
        </div>
    </div>
</template>

<script>
import {RoleServiceClient, CreateRoleDto, RoleDto, ListResultDtoOfPermissionDto} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import Enum from '@/shared/enum'

export default {
  name: 'CreateRole',
  mixins: [CrudMixin],

  data() {
    let dto = new CreateRoleDto()
    dto.init({isStatic: 0})
    dto.permissions = []

    return {
      ready: false,
      error: '',
      role: dto,
      permissions: [],
    }
  },
  methods: {
    cleanEntity: function() {
      let cleanRole = this.cleanFields(this.role)

      cleanRole.permissions = _(this.permissions)
        .filter(f => f.checked)
        .map(m => m.name)
        .value()

      return cleanRole
    },
    createRole: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let service = ServiceFactory.create(RoleServiceClient)

            service
              .create(this.cleanEntity())
              .then(res => {
                this.$swal('Succès', this.$t('role.create.succes'), 'success')
                this.$router.push({path: '/roles'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editRole: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let service = ServiceFactory.create(RoleServiceClient)

            service
              .update(this.cleanEntity())
              .then(res => {
                this.$swal('Succès', this.$t('role.edit.succes'), 'success')
                this.$router.push({path: '/roles'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchData: function() {
      let service = ServiceFactory.create(RoleServiceClient)

      let self = this

      let getAllPermissions = service.getAllPermissions()

      getAllPermissions.then(res => {
        self.permissions = res.items
      })

      let promisseAll

      if (this.compMode != Enum.Mode.CREATE) {
        let getRole = service.get(this.$route.params.id)
        getRole
          .then(res => {
            self.role = res
            self.checkCopyMode(self.partner)
          })
          .catch(err => {
            self.getErrorMessage(err)
          })

        promisseAll = Promise.all([getAllPermissions, getRole])
      } else {
        promisseAll = Promise.all([getAllPermissions])
      }

      promisseAll.then(v => {
        self.ready = true

        if (self.role.id != null) {
          for (var i = 0; i < self.permissions.length; i++) {
            if (
              _.findIndex(self.role.permissions, function(item) {
                return item == self.permissions[i].name
              }) >= 0
            ) {
              self.$set(self.permissions[i], 'checked', true)
            } else {
              self.$set(self.permissions[i], 'checked', false)
            }
          }
        } else {
          for (let i = 0; i < self.permissions.length; i++) self.$set(self.permissions[i], 'checked', false)
        }
      })
    },
  },
  components: {
    errorMessage: ErrorMessage,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .btn-primary {
    color: #fff !important;
    cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/roles/Create.vue